import listService      from 'ListService.js';
import mobileListService from './MobileListService';

class MobileGroupService {

    constructor() {}

    ungroupControl(controlId, groupId, parentId) {

        const wizardControl = mobileListService.getMobileControl(controlId);

        if (wizardControl && wizardControl.model) {
            wizardControl.model._groupId = groupId;
            wizardControl.groupId = groupId;
            wizardControl.pageId = parentId;
        }

        const mobileControl = listService.getMobileObject(controlId);
        if (mobileControl && mobileControl.groupId) {
            mobileControl.groupId = groupId;
        }
    }


    regroupControl(controlId, groupId) {
        const mobileControl = listService.getMobileObject(controlId);
        if (mobileControl) {
            mobileControl.groupId = groupId;

            if(mobileControl.sectionId && mobileControl.sectionId !== ''){
                mobileControl.sectionId = '';
                return true;
            }
        }
        return false
    }
}


export  default new MobileGroupService();